import { IStoreState } from "Interfaces";

export const leftMenuSelector = (state: IStoreState) => state.leftMenu;
